import { Injectable, EventEmitter } from "@angular/core";
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSaveSendDialogService {
  active = false;
  active$ = new EventEmitter();

  zIndex = 0;

  addToXref$ = new Subject();
  sendToEmail$ = new Subject();

  constructor() {}

  show() {
    this.active = true;
    this.active$.emit(true);
  }

  hide() {
    this.active = false;
    this.active$.emit(false);
  }
}
